import { useQuery } from 'react-query';
import { getData } from '../models/score/api';

export const useScore = (teamId) => {
  return useQuery(
    ['useScore', teamId],
    async () => getData(teamId).then((result) => result.data),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 1,
      enabled: !!teamId,
    }
  );
};
